// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Iuf6t","loaderImg":"Loader_loaderImg__3gvVK","wobble-pulse":"Loader_wobble-pulse__psV0k","loaderStarting":"Loader_loaderStarting__+XWXu"};